import { RecentAirSearch } from '@shared/types';

/**
 * Function that returns the allowed origin
 * @param {string} defaultOrigin the default origin
 * @param {string} allowedOrigins string of allowed origins. Eg: "ROC,BGI"
 * @param {string[]} nearbyAirportCodes neraby airport codes
 * @param {RecentAirSearch[]} recentAirports the recent airport searches
 * @returns {string} returns a string value with the selected default airport code. Eg: "NYC"
 */
export const getDefaultAllowedOrigin = (
  defaultOrigin: string,
  allowedOrigins: string,
  nearbyAirportCodes: string[],
  recentAirports: RecentAirSearch[],
): string => {
  let selectedOrigin = defaultOrigin;
  if (allowedOrigins) {
    const allowedOriginsArray = allowedOrigins.split(',');
    if (recentAirports.length) {
      const recentAirport = recentAirports[0].originCode[0];
      if (allowedOriginsArray.includes(recentAirport)) {
        selectedOrigin = recentAirports[0].originCode[0];
      }
    } else if (nearbyAirportCodes.length) {
      const nearbyAirportCode = nearbyAirportCodes[0];
      if (allowedOriginsArray.includes(nearbyAirportCode)) {
        selectedOrigin = nearbyAirportCode;
      }
    } else {
      if (!allowedOriginsArray.includes(selectedOrigin)) {
        selectedOrigin = defaultOrigin;
      }
    }
  } else {
    // all allowed origins
    if (recentAirports.length) {
      selectedOrigin = recentAirports[0].originCode[0];
    } else if (nearbyAirportCodes.length) {
      selectedOrigin = nearbyAirportCodes[0];
    }
  }
  return selectedOrigin;
};
